module.exports = __webpack_public_path__ + "static/media/model-mission-13.05dd4c9c.png";